const BASE_API_SHAREABLELINK = '/api/company/invite/shareable-link';
export const shareableLink = BASE_API_SHAREABLELINK;
export const toggle = `${BASE_API_SHAREABLELINK}/toggle`;
export const regenerate = `${BASE_API_SHAREABLELINK}/regenerate`;
export const deactivate = `${BASE_API_SHAREABLELINK}/deactivate`;
